export default "__VITE_ASSET__BidSShU6__"